import moment from "moment";
import { useSearchFeeGroupTotalsQuery } from "../../../services/headofficeadmin";
import { useAdministrationFeesProvider } from "../../../hooks/AdministrationFeesContext";

const useFeeTotals = (searchType) => {
    const {filters, isReady, currentSearchType} = useAdministrationFeesProvider();

    //console.log('totals filter for fees or cash - type ',searchType, 'filter ',filters);

    const { data, isLoading, isFetching, isError, error, refetch } = useSearchFeeGroupTotalsQuery({
        searchType:currentSearchType,
        filter:{
        ...filters,
        adviserIds: filters?.advisers?.map(x => x.value) ?? [],
        introducerIds: filters?.introducers?.map(x => x.value) ?? [],
        masterAccountIds: filters?.masterAccounts?.map(x => x.value) ?? [],
        providerIds: filters?.providers?.map(x => x.value) ?? [],
        startDate: filters?.startDate ?? moment().startOf('month').format('YYYY/MM/DD'),
        endDate: filters?.endDate ?? null,
    }});

    

    const retryGetFeeTotals = (e) => {
        if (e && typeof (e.preventDefault) === "function") {
            e.preventDefault();
        }
        refetch();
    }

    return {
        data,
        isFetching,
        isLoading,
        isError,
        error,
        retryGetFeeTotals
    }
};

export default useFeeTotals;